import {FC} from 'react';
import clsx from 'clsx';
import {Text} from '@mantine/core';

import {NotificationType, TNotification} from '~/services/hot-api/notifications';
import Modal from '~/common/display/Modal';
import Icon, {Icons} from '~/common/Icon';
import {formatDate} from '~/utils/dates';

import s from './styles.module.scss';
import {ActionsMap} from '../../constants';

interface NotificationModalProps {
  opened: boolean;
  onClose: () => void;
  notification: TNotification;
  onAction: () => void;
}

const NotificationModal: FC<NotificationModalProps> = ({
  opened,
  onClose,
  notification,
  onAction,
}) => {
  const notificationType = notification.type || NotificationType.info;

  return (
    <Modal opened={opened} onClose={onClose} className={s['notification-modal']} centered>
      <div className={s.notification__header}>
        <Icon
          name={Icons.infoCircle}
          className={clsx(s.notification__icon, s[`notification__icon--${notificationType}`])}
        />
        <div>
          <div className={s.notification__title}>{notification.title}</div>
        </div>
      </div>
      <div>
        <Text className={s.notification__content} mt={12}>
          {notification.content}
        </Text>
        <div className={s['notification-modal__date']}>
          {formatDate(notification.added, 'MMMM d, HH:mm')}
        </div>
      </div>
      <div className={s.notification__actions}>
        {notification.actions.map((action) => {
          const Component = ActionsMap[action.type];

          if (!Component) {
            console.warn(`No component for action type: ${action.type}`);
            return null;
          }

          return (
            <Component
              key={action.type}
              // TODO: make type on of Pick<NotificationPayloadMap, T>
              payload={action.payload as any}
              onClose={onClose}
              onAction={onAction}
            />
          );
        })}
      </div>
    </Modal>
  );
};

export default NotificationModal;
